import angular from "angular";

angular
    .module('app')
    .component('userSearch', {
        template: require('./user-search.html'),
        controller: ['$http', controller],
        bindings: {
            user: '=',
            userChanged: '&'
        }
    });

function controller($http) {

    let $ctrl = this;

    $ctrl.user = null;

    $ctrl.getUsers = function (fragment) {
        return $http
            .get('/admin/users/get-by-fragment', {params: {fragment}})
            .then(
                function (response) {
                    console.log(response);
                    return response.data.users;
                }
            )
    };

    $ctrl.userSelected = function () {
        $ctrl.userChanged({user: $ctrl.user});
    };

    $ctrl.userChanged = function () {
        if (!$ctrl.user) {
            $ctrl.userChanged({user: null});
        }
    };
}
